<form [formGroup]="form">
    <app-website-config-form-expansion-panel [title]="'Geschäftsdaten'">
        <div formGroupName="contactData">

            <p class="admin-text headline">Basisdaten</p>
            <div class="admin-row no-border-bottom">
                <div class="cell">
                    <mat-form-field class="table-width" appearance="outline">
                        <mat-label>Name des Geschäfts</mat-label>
                        <input required matInput placeholder="Name des Geschäfts" formControlName="name">
                        <mat-icon matSuffix matTooltip="Name des Geschäfts gegenüber Kunden.">help</mat-icon>
                    </mat-form-field>
                </div>
                <div class="cell">
                    <mat-form-field class="table-width" appearance="outline">
                        <mat-label>Straße + Hausnummer</mat-label>
                        <input matInput placeholder="Straße" formControlName="street">
                    </mat-form-field>
                </div>
                <div class="cell">
                    <mat-form-field class="table-width" appearance="outline">
                        <mat-label>PLZ und Stadt</mat-label>
                        <input matInput placeholder="Stadt" formControlName="city">
                    </mat-form-field>
                </div>
            </div>
            <div class="admin-row no-border-bottom">
                <div class="cell">
                    <mat-form-field class="table-width" appearance="outline">
                        <mat-label>Telefonnummer</mat-label>
                        <input matInput placeholder="Telefon" formControlName="phone">
                    </mat-form-field>
                </div>
                <div class="cell">
                    <mat-form-field class="table-width" appearance="outline">
                        <mat-label>Handynummer</mat-label>
                        <input matInput placeholder="Handynummer" formControlName="mobile">
                    </mat-form-field>
                </div>
                <div class="cell">
                    <mat-form-field class="table-width" appearance="outline">
                        <mat-label>E-Mail</mat-label>
                        <input matInput placeholder="E-Mail" formControlName="email">
                        @if(form.get('contactData.email')?.hasError('email') &&
                        form.get('contactData.email')?.touched) {
                        <mat-error>E-Mail ungültig.</mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
        </div>
    </app-website-config-form-expansion-panel>

    <app-website-config-form-expansion-panel [title]="'Unternehmensdaten'">
        <p class="admin-text headline">Basisdaten</p>
        <div formGroupName="businessData">
            <div class="admin-row no-border-bottom">
                <div class="cell">
                    <mat-form-field class="table-width" appearance="outline">
                        <mat-label>Name des Unternehmens</mat-label>
                        <input required matInput placeholder="Name des Unternehmens" formControlName="businessName">
                        <mat-icon matSuffix
                            matTooltip="Offizieller Unternehmensname so wie er beispielsweise auf Rechnungen oder der Steuererklärungen auftritt.">help</mat-icon>
                    </mat-form-field>
                </div>
                <div class="cell">
                    <mat-form-field class="table-width" appearance="outline">
                        <mat-label>Geschäftsform</mat-label>
                        <mat-select required panelClass="admin-theme" formControlName="businessType">
                            @for (businessForm of businessTypes; track businessForm) {
                            <mat-option [value]="businessForm">{{businessForm}}</mat-option>
                            }
                        </mat-select>
                        <mat-icon matSuffix
                            matTooltip="Sollte eine andere Unternemensform vorliegen, kontaktieren Sie uns bitte.">help</mat-icon>
                    </mat-form-field>
                </div>
                <div class="cell">
                    <mat-form-field class="table-width" appearance="outline">
                        <mat-label>Umsatzsteuer-ID</mat-label>
                        <input matInput placeholder="Umsatzsteuer-ID" formControlName="vatId">
                        <mat-icon matSuffix
                            matTooltip="Falls keine Umsatzsteuer-ID existiert, lassen Sie das Feld frei.">help</mat-icon>
                    </mat-form-field>
                </div>
            </div>
            <div class="admin-row no-border-bottom">
                <div class="cell">
                    <mat-form-field class="table-width" appearance="outline">
                        <mat-label>Registernummer</mat-label>
                        <input matInput placeholder="Registernummer" formControlName="registrationNumber">
                        <mat-icon matSuffix
                            matTooltip="Falls keine Registernummer existiert, lassen Sie das Feld frei.">help</mat-icon>
                    </mat-form-field>
                </div>
                <div class="cell">
                    <mat-form-field class="table-width" appearance="outline">
                        <mat-label>Registergericht</mat-label>
                        <input matInput placeholder="Registergericht" formControlName="registrationCity">
                        <mat-icon matSuffix
                            matTooltip="Falls keine Registernummer existiert, lassen Sie das Feld frei.">help</mat-icon>
                    </mat-form-field>
                </div>
            </div>

            <p class="admin-text headline">Unternehmenskontakt</p>
            <div formGroupName="businessStreet">
                <div class="admin-row no-border-bottom">
                    <div class="sub-cell">
                        <mat-form-field class="table-width" appearance="outline">
                            <mat-label>Straße + Hausnummer Unternehmen</mat-label>
                            <input matInput placeholder="Straße + Hausnummer Unternehmen" formControlName="value">
                        </mat-form-field>
                    </div>
                    <div class="sub-cell">
                        <mat-checkbox formControlName="syncWithContactData"
                            (change)="toggleInput('businessData.businessStreet')">
                            Mit Geschäftsdaten synchronisieren
                        </mat-checkbox>
                    </div>
                </div>
            </div>
            <div formGroupName="businessCity">
                <div class="admin-row no-border-bottom">
                    <div class="sub-cell">
                        <mat-form-field class="table-width" appearance="outline">
                            <mat-label>PLZ und Stadt Unternehmen</mat-label>
                            <input matInput placeholder="PLZ und Stadt Unternehmen" formControlName="value">
                        </mat-form-field>
                    </div>
                    <div class="sub-cell">
                        <mat-checkbox formControlName="syncWithContactData"
                            (change)="toggleInput('businessData.businessCity')">
                            Mit Geschäftsdaten synchronisieren
                        </mat-checkbox>
                    </div>
                </div>
            </div>
            <div formGroupName="businessContactPhone">
                <div class="admin-row no-border-bottom">
                    <div class="sub-cell">
                        <mat-form-field class="table-width" appearance="outline">
                            <mat-label>Telefon Unternehmen</mat-label>
                            <input matInput placeholder="Telefon Unternehmen" formControlName="value">
                        </mat-form-field>
                    </div>
                    <div class="sub-cell">
                        <mat-checkbox formControlName="syncWithContactData"
                            (change)="toggleInput('businessData.businessContactPhone')">
                            Mit Geschäftsdaten synchronisieren
                        </mat-checkbox>
                    </div>
                </div>
            </div>
            <div formGroupName="businessContactEmail">
                <div class="admin-row no-border-bottom">
                    <div class="sub-cell">
                        <mat-form-field class="table-width" appearance="outline">
                            <mat-label>E-Mail Unternehmen</mat-label>
                            <input matInput placeholder="E-Mail Unternehmen" formControlName="value">
                        </mat-form-field>
                    </div>
                    <div class="sub-cell">
                        <mat-checkbox formControlName="syncWithContactData"
                            (change)="toggleInput('businessData.businessContactEmail')">
                            Mit Geschäftsdaten synchronisieren
                        </mat-checkbox>
                    </div>
                </div>
            </div>


            <p class="admin-text headline">Inhaber / Geschäftsführer</p>
            <div formArrayName="businessContactNames">
                @if (businessContactNames.controls.length) {
                    @for(contactName of businessContactNames.controls; let i = $index; track contactName;) {
                        <div [formGroupName]="i">
                            <div class="admin-row no-border-bottom distribution-row">
                                <div class="admin-row-element">
                                        <mat-form-field class="table-width" appearance="outline">
                                            <mat-label>Vorname {{businessContactLabel}}</mat-label>
                                            <input matInput placeholder="Vorname {{businessContactLabel}}"
                                                id="firstname-{{ i }}" formControlName="firstname">
                                        </mat-form-field>
                                        <mat-form-field class="table-width" appearance="outline">
                                            <mat-label>Nachname {{businessContactLabel}}</mat-label>
                                            <input matInput placeholder="Nachname {{businessContactLabel}}" id="surname-{{ i }}"
                                                formControlName="surname">
                                        </mat-form-field>
                                </div>

                                <button mat-icon-button (click)="removeBusinessContactName(i)" [disabled]="businessContactNames.controls.length < 2">
                                    <mat-icon class="error">remove_circle</mat-icon>
                                </button>

                            </div>
                        </div>
                        <mat-divider></mat-divider>
                    }
                }
                <div class="add-action">
                    <button mat-mini-fab (click)="addBusinessContactName()" [disabled]="form.get('businessData.businessContactNames')?.invalid">
                        <mat-icon class="admin-success">add</mat-icon>
                    </button>
                </div>
            </div>

        </div>
    </app-website-config-form-expansion-panel>
</form>